import { render, staticRenderFns } from "./CollectionsDataSourcesConditions.vue?vue&type=template&id=64bb0716&scoped=true"
import script from "./CollectionsDataSourcesConditions.vue?vue&type=script&lang=js"
export * from "./CollectionsDataSourcesConditions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64bb0716",
  null
  
)

export default component.exports